module.exports = __webpack_public_path__ + "img/swtck@2x.ec2eec88.png";